/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from "vue";
import App from "./App.vue";
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Component from "vue-class-component";

import awsconfig from "./config";
Vue.config.productionTip = false;

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: awsconfig.cognito.REGION,
    userPoolId: awsconfig.cognito.USER_POOL_ID,
    identityPoolId: awsconfig.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: awsconfig.cognito.APP_CLIENT_ID
  }
});

Vue.use(AmplifyPlugin, AmplifyModules);

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate"
]);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
